<template>
  <div id="app">
    <FinancialGoalCalculator :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import FinancialGoalCalculator from "./components/FinancialGoalCalculator.vue";

export default {
  name: "App",
  components: {
    FinancialGoalCalculator,
  },
};
</script>

<style>
#app {
}
</style>
